
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faBolt as farBolt,
    } from '@fortawesome/pro-regular-svg-icons/faBolt';

    import {
        faHandshake as farHandshake,
    } from '@fortawesome/pro-regular-svg-icons/faHandshake';

    import {
        faGem as farGem,
    } from '@fortawesome/pro-regular-svg-icons/faGem';

    import Accordion from '@/components/Utils/Accordion';

    export default {
        name: 'SectionFaq',

        components: {
            FontAwesomeIcon,
            Accordion,
        },

        data() {
            return {
                icons: {
                    farBolt,
                    farHandshake,
                    farGem,
                },
            };
        },
    };
